import { Paginator } from "primereact/paginator"
import React from "react"
import { classNames } from 'primereact/utils';

function PaginatorComp({ title, first, rows, totalRecords, onPageChange, ...rest }) {
    const template3 = {
        layout: 'FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink',
        // RowsPerPageDropdown: (options) => {
        //     return (
        //         <div className="flex align-items-center">
        //             <Tooltip target=".slider>.p-slider-handle" content={`${options.value} / page`} position="top" event="focus" />

        //             <span className="mr-3" style={{ color: 'var(--text-color)', userSelect: 'none' }}>
        //                 Items per page:{' '}
        //             </span>
        //             <Slider className="slider" value={options.value} onChange={options.onChange} min={10} max={120} step={30} style={{ width: '10rem' }} />
        //         </div>
        //     );
        // },
        CurrentPageReport: (options) => {
            return (
                <span style={{ marginRight:"45%",color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
                    Showing {options.first} - {options.last} of {options.totalRecords} {title}
                </span>
            );
        },
        FirstPageLink: (options) => {
            return (
                <button type="button" className={classNames(options.className, 'border-round')} onClick={options.onClick} disabled={options.disabled}>
                <span className="p-3"><i className="pi pi-angle-double-left"/> First</span>
                {/* <Ripple /> */}
            </button>
            );
        },
        PrevPageLink: (options) => {
            return (
                <button type="button" className={classNames(options.className, 'border-round')} onClick={options.onClick} disabled={options.disabled}>
                    <span className="p-3"><i className="pi pi-angle-left"/> Back</span>
                    {/* <Ripple /> */}
                </button>
            );
        },
        NextPageLink: (options) => {
            return (
                <button type="button" className={classNames(options.className, 'border-round')} onClick={options.onClick} disabled={options.disabled}>
                    <span className="p-3">Next <i className="pi pi-angle-right"/></span>
                    {/* <Ripple /> */}
                </button>
            );
        },
        LastPageLink: (options) => {
            return (
                <button style={{textAlign:"right"}} type="button" className={classNames(options.className, 'border-round')} onClick={options.onClick} disabled={options.disabled}>
                <span className="p-3"> Last <i className="pi pi-angle-double-right"/></span>
                {/* <Ripple /> */}
            </button>
            );
        },
    };
    return <Paginator
        template={template3}
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        onPageChange={onPageChange}
        {...rest}
    />
}
export default PaginatorComp